import { useSnackbar, SnackbarType } from '@tapp.online/ui'
export const useCopy = () => {
    const { addSnackbar } = useSnackbar()
    const copyValue = (value?: string) => {
        if (!value) return
        try {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(value)
            } else {
                const input = document.createElement('textarea')
                input.value = value
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                document.body.removeChild(input)
            }
            addSnackbar({
                title: 'Copied',
                text: value,
                type: SnackbarType.SUCCESS,
                duration: 2000
            })
        } catch (error) {
            console.error(error)
            addSnackbar({
                title: 'Oops',
                text: `Failed to copy value`,
                type: SnackbarType.ERROR,
                duration: 2000
            })
        }
    }
    return { copyValue }
}
